import request from '../../src/untils/request'

export const tableData = params => {
    return request({
        method:'GET',
        url:'/index/search_phone',
        params
    })
}